import { createQuery } from '@tanstack/solid-query';
import { readSession } from '~/shared/api/http-client';
import { type ClubScheduleConfig, settingsApi } from '~/shared/api/settings-api';
import { CLUB_ZONE_FALLBACK } from '~/shared/lib/clubZone';

export const clubScheduleQuery = (): {
  queryKey: readonly ['settings', 'club', 'schedule'];
  queryFn: (context: { signal: AbortSignal }) => Promise<ClubScheduleConfig>;
  staleTime: number;
} => ({
  queryKey: ['settings', 'club', 'schedule'] as const,
  queryFn: ({ signal }) => settingsApi.getClubSchedule({ signal }),
  staleTime: 30_000,
});

export const useClubZone = (): (() => string) => {
  const query = createQuery(clubScheduleQuery);
  return () => {
    const zone = query.data?.timezone || readSession()?.user.clubTimezone;
    return zone && zone.length > 0 ? zone : CLUB_ZONE_FALLBACK;
  };
};
